import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import { isArray, runIfFn, get, warn } from "@chakra-ui/utils";
import { createProcessor } from "./create-processor";
import { transformConfig } from "./utils";
var fallbackBreakpoints = {
  sm: 400,
  md: 700,
  lg: 1000
};
export function createParser(styleConfig) {
  var cache = {};

  var parser = function parser(props) {
    var _cache$breakpoints;
    /**
     * Get the breakpoints from theme or cache
     */


    cache.breakpoints = (_cache$breakpoints = cache.breakpoints) != null ? _cache$breakpoints : get(props.theme, "breakpoints", fallbackBreakpoints);
    /**
     * Create a style processor based on the breakpoints
     */

    var processor = createProcessor(cache.breakpoints);

    var _config = transformConfig(styleConfig, props.theme);

    var _loop = function _loop(prop) {
      /**
       * No need to process if prop is `theme`, or there's no config for prop
       */
      if (prop === "theme" || styleConfig[prop] == null) return "continue";
      var valueOrFn = props[prop];
      var value = runIfFn(valueOrFn, props.theme);
      /**
       * Get the config for the style prop
       */

      var config = _config[prop];
      warn({
        condition: config.deprecated,
        message: prop + " is deprecated. Kindly use " + config.replacement + " instead"
      });
      /**
       * Apply each prop's config to get the generate style object.
       *
       * If it's an array config:
       *
       * @example
       * marginX = ["marginLeft", "marginRight"]
       *
       * We'll expand it to `marginLeft` and `marginRight`
       */

      if (isArray(config)) {
        config.forEach(function (opt) {
          processor.apply(_extends({}, opt, {
            value: value,
            props: props
          }));
        });
      } else {
        var options = _extends({}, config, {
          value: value,
          props: props
        });

        processor.apply(options);
      }
    };

    for (var prop in props) {
      var _ret = _loop(prop);

      if (_ret === "continue") continue;
    }

    return processor.value();
  };

  parser.config = styleConfig;
  parser.propNames = Object.keys(styleConfig);
  return parser;
}